import React, { useState } from "react";
import { C } from "../constants/design";
import { useI18n } from "../i18n/I18nContext";

const NICK_RE = /^[A-Za-z0-9_.가-힣㄰-㆏ᄀ-ᇿ]{3,14}$/;

function validateNickname(n: string, t: (k: string) => string): string | null {
  const v = n.trim();
  if (v.length < 3) return t("login.atLeast3Chars");
  if (v.length > 14) return t("login.max14Chars");
  if (!NICK_RE.test(v)) return t("login.invalidChars");
  return null;
}

export function NicknameSetup({ onSubmit }: { onSubmit: (nickname: string) => Promise<string | void> }) {
  const { t } = useI18n();
  const [nick, setNick] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const handleSubmit = async () => {
    const err = validateNickname(nick, t);
    if (err) { setError(err); return; }
    setBusy(true);
    // onSubmit returns an error message when the nickname is rejected (e.g. taken)
    const submitErr = await onSubmit(nick.trim());
    if (submitErr) { setError(submitErr); setBusy(false); }
  };

  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "32px 22px",
        gap: 4,
      }}
    >
      <div style={{ textAlign: "center", marginBottom: 28 }}>
        <div style={{ fontSize: 42, marginBottom: 4 }}>⚽🏆</div>
        <div className="d" style={{ fontSize: 30, fontWeight: 900, letterSpacing: -0.5 }}>
          Prono<span style={{ color: C.turf }}>Cup</span>
        </div>
        <div style={{ fontSize: 15, color: C.muted, marginTop: 12 }}>
          {t("nicknameSetup.signedInChooseNickname")}
        </div>
      </div>

      <label style={{ fontSize: 12, fontWeight: 800, color: C.muted, marginBottom: 6 }}>
        {t("nicknameSetup.nicknameLabel")}
      </label>
      <input
        value={nick}
        maxLength={14}
        autoFocus
        onChange={(e) => { setNick(e.target.value); setError(null); }}
        onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
        placeholder={t("nicknameSetup.playerNamePlaceholder")}
        style={{
          background: C.surface,
          border: `1px solid ${error ? "#ef4444" : C.line}`,
          borderRadius: 12,
          padding: "13px 14px",
          color: C.text,
          fontSize: 15,
          outline: "none",
        }}
      />
      {error && (
        <div style={{ color: "#ef4444", fontSize: 12, fontWeight: 600, marginTop: 6 }}>
          {error}
        </div>
      )}

      <button
        onClick={handleSubmit}
        disabled={busy}
        style={{
          marginTop: 16,
          border: "none",
          borderRadius: 12,
          padding: "15px",
          fontWeight: 600,
          fontSize: 16,
          background: "#48FF85",
          color: "#06121e",
          cursor: busy ? "default" : "pointer",
          opacity: busy ? 0.6 : 1,
        }}
      >
        {busy ? t("nicknameSetup.creating") : t("nicknameSetup.startPlaying")}
      </button>
    </div>
  );
}
